"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var StickyBarModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyBarModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const merge_1 = __importDefault(require("lodash/merge"));
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const StickyBar_contracts_1 = require("./StickyBar.contracts");
const validate_js_1 = require("validate.js");
const StickyBar_config_1 = require("./StickyBar.config");
let StickyBarModuleForm = StickyBarModuleForm_1 = class StickyBarModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        this.stickyBarConfig = StickyBar_config_1.stickyBarConfig;
        this.hasExternalLink = true;
        this.img = null;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = StickyBarModuleForm_1.getInitialContent();
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.StickyBar,
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: false
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            color: StickyBar_contracts_1.StickyBarColor.Brand,
            label: '',
            image: {},
            readMoreUrl: '',
            readMoreLink: null
        };
    }
    get color() {
        return this._content.color;
    }
    set color(value) {
        if (!value) {
            return;
        }
        this._content.color = value;
    }
    get colorClass() {
        if (!this.color) {
            return '';
        }
        return this.stickyBarConfig[this.color] ? this.stickyBarConfig[this.color] : '';
    }
    get colorOptions() {
        // For some reason this enum in Object.values returns array of values and keys (one lower case, second capitalize),
        // That's why this method with set and mapping to lower case.
        return [...new Set(Object.values(StickyBar_contracts_1.StickyBarColor).map(value => `${value}`.toLowerCase()))]
            .map(value => {
            return {
                label: this.$t('forms.stickyBar.colors.' + value),
                value: value
            };
        });
    }
    get hasRelatedLink() {
        return !!(this._content.readMoreLink && typeof this._content.readMoreLink !== 'string' &&
            typeof this._content.readMoreLink.value !== 'undefined' && typeof this._content.readMoreLink.type !== 'undefined');
    }
    /**
     * @inheritDoc
     * @override
     */
    afterInitialContentSetup() {
        this.$nextTick(() => {
            if (!!this._content.readMoreLink && !!this._content.readMoreLink.value) {
                this.describe(this._content.readMoreLink);
            }
            this.findImageRelated();
        });
    }
    /**
     * @inheritDoc
     * @override
     */
    setInitialContent() {
        this._content = merge_1.default(this.initialContent, this._content);
    }
    deleteLinkSource() {
        if (!this._content.readMoreLink) {
            return;
        }
        const contentCopy = { ...this._content };
        delete contentCopy.readMoreLink;
        this._content = contentCopy;
    }
    deleteImageSource() {
        if (!this._content.image) {
            return;
        }
        const contentCopy = { ...this._content };
        delete contentCopy.image;
        this.img = null;
        this._content = contentCopy;
    }
    /**
     * Check that image is define
     */
    hasImage() {
        return !!this._content.image && typeof this._content.image.value !== 'undefined';
    }
    /**
     * Get image source form picker
     */
    findImageSource() {
        this.pickRelated(services_1.Picker.Media, this.setImageSource);
    }
    /**
     * Get link source form picker
     */
    findLinkSource() {
        this.pickRelated(services_1.Picker.Content, this.setLinkSource);
    }
    findImageRelated() {
        if (typeof this._content.image === 'undefined' || !this.hasImage()) {
            return;
        }
        const related = this.relatedService.resolve(this._content.image, {});
        if (!validate_js_1.isPromise(related)) {
            return;
        }
        related.then((related) => {
            if (Object.prototype.hasOwnProperty.call(related, 'file')) {
                this.img = {
                    type: related.file.type,
                    thumbnail: related.url
                };
            }
            else if (Object.prototype.hasOwnProperty.call(related, 'url')) {
                this.img = {
                    type: backoffice_1.ImageType.JPG,
                    thumbnail: related.url
                };
            }
        }).catch(error => {
            console.debug(error);
        });
    }
    onHasExternalLinkChange(value) {
        this.hasExternalLink = value;
        if (value) {
            if (this._content.readMoreLink) {
                const contentCopy = { ...this._content };
                delete contentCopy.readMoreLink;
                this._content = contentCopy;
            }
        }
        else {
            if (this._content.readMoreUrl && typeof this._content.readMoreUrl === 'string') {
                const contentCopy = { ...this._content };
                delete contentCopy.readMoreUrl;
                this._content = contentCopy;
            }
        }
    }
    /**
     * Set image selected form picker
     */
    setImageSource(source) {
        this._content.image = source;
        this.$nextTick(() => {
            this.findImageRelated();
        });
    }
    /**
     * Set redirect selected form picker
     */
    setLinkSource(source) {
        if (this._content.readMoreLink) {
            this._content.readMoreLink = source;
        }
        else {
            this._content = {
                ...this._content,
                readMoreLink: source
            };
        }
        this.$nextTick(() => {
            this.describe(source);
        });
    }
};
__decorate([
    vue_property_decorator_1.Watch('hasExternalLink', { deep: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], StickyBarModuleForm.prototype, "onHasExternalLinkChange", null);
StickyBarModuleForm = StickyBarModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'StickyBarModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixFile: backoffice_1.DashmixFile,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixSelect: backoffice_1.DashmixSelect,
            FormErrors: form_2.FormErrors
        },
        template: `
    <div>
      <!-- Colors -->
      <div class="form-group">
        <label for="color">{{ $t('forms.stickyBar.colorsLabels') }}</label>
        <div class="sticky-bar__select">
          <DashmixSelect :model.sync="color" name="color" :options="colorOptions" :searchable="false" />
          <div class="sticky-bar__selected-color" :class="colorClass" />
        </div>
      </div>

      <div class="form-group mb-4">
        <label for="label" class="d-block">{{ $t('forms.stickyBar.label') }}</label>
        <DashmixInput :model.sync="_content.label" name="label" />
      </div>

      <div class="form-group mb-4">
        <label for="link" class="d-block">{{ $t('forms.stickyBar.link') }}</label>

        <DashmixCheck class="pb-3" :label="$t('forms.stickyBar.hasExternalLink')" name="hasExternalLink"
                      :model.sync="hasExternalLink"/>

        <template v-if="!hasExternalLink">
          <DashmixButton v-if="!hasRelatedLink" variant="alt" :icon="icons.SearchSolid"
                         :label="$t('forms.stickyBar.chooseLink')"
                         @click="findLinkSource"/>

          <div class="row" v-else>
            <div class="col d-flex align-items-center">
              <p class="mb-0">
                <strong class="mr-2">{{ $t('forms.shared.chosenLink') }}</strong>
                {{ description(_content.readMoreLink) }}
              </p>
            </div>
            <div class="col-3 d-flex text-right">
              <DashmixButton variant="icon" :icon="icons.PenSolid" @click="findLinkSource"/>
              <DashmixButton theme="danger" variant="icon" :icon="icons.TrashSolid" @click="deleteLinkSource"/>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="form-group">
            <label for="urlPath" class="d-block">{{ $t('forms.stickyBar.linkUrl.label') }}</label>
            <DashmixInput :model.sync="_content.readMoreUrl" name="urlPath"
                          :placeholder="$t('forms.stickyBar.linkUrl.placeholder')"/>
          </div>
        </template>
      </div>

      <div class="form-group mb-4">
        <label for="image" class="d-block">{{ $t('forms.stickyBar.image') }}</label>

        <div v-if="hasImage && img" class="row">
          <figure class="col-3">
            <DashmixFile style="width: 100px" :file="img"/>
          </figure>

          <div class="col-3 d-flex text-right">
            <DashmixButton variant="icon" :icon="icons.PenSolid" @click="findImageSource"/>
            <DashmixButton theme="danger" variant="icon" :icon="icons.TrashSolid" @click="deleteImageSource"/>
          </div>
        </div>
        <DashmixButton v-else variant="alt" :icon="icons.SearchSolid"
                       :label="$t('forms.stickyBar.chooseImage')" @click="findImageSource"/>
      </div>

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], StickyBarModuleForm);
exports.StickyBarModuleForm = StickyBarModuleForm;
//# sourceMappingURL=StickyBar.form.js.map